<template>
     <div class="c-user" v-if="data" :class="{'has-action': data.urls}">
        <router-link
        v-if="data.urls && data.urls.edit"
        class="st-table__link"
        :to="editurl">{{ name }}</router-link>
        <span v-else>{{ name }}</span>


		<div v-if="isSomeoneEditing">
			{{ $t('Someone is currently editing this User. Please try again later.') }}
		</div>
        <div class="st-table-action" v-else-if="data.urls && !simple">
        	<router-link class="st-table-action__link st-table-action__link--edit" v-if="data.urls.edit" :to="editurl">{{ $t('Edit') }}</router-link>
        </div>

        <v-tooldown v-if="deleteel && isdeleting" :loading="loading" :type="'delete'" :el="deleteel" :yesno="true" @ok="deleteuser" @cancel="stopdeleteuser">
        	<span v-cloak slot="title">{{ $t('Delete User') }}</span>
        	<span v-cloak slot="message">{{ $t('Do you really want to delete this user.') }}</span>
        	<span v-cloak slot="positive">{{ $t('Delete') }}</span>
        </v-tooldown>
    </div>
    <div v-else>
    	<pre>{{ data }}</pre>
    </div>
</template>

<script>

// helper
import help_rest from '@/helpers/rest';
import forEach from 'lodash/forEach';

export default {
  	name: 'c-user',
  	data(){
  		return {
  			loading: false,
  			isdeleting: false,
  			deleteel: false
  		}
  	},

	computed: {
		isSomeoneEditing(){
			var user_edit_status = this.$store.getters['socket/getFromLive']('user_edit_status');
			if(!user_edit_status || typeof user_edit_status[this.data.id] === 'undefined') return false;
  			return true;
		},
		name(){
			if(this.data.lastname && this.data.firstname) return this.data.lastname + ', ' + this.data.firstname;

			return this.data.title;
		},
		editurl(){
			if(this.data.partner_id){
				return {
					name: 'partner-user',
					params: {
						id: this.data.partner_id,
						uid: this.data.id
					}
				};
			}
			return { path: this.data.urls.edit };
		}
	},

	props: {
		data: {
			default: function () {
				return {};
			}
	    },
	    simple: {
			type: Boolean,
			default: false
	    }
	},
	methods: {
		...help_rest,
		startdeleteuser(event){
			this.deleteel = event.target;
			this.isdeleting = !this.isdeleting;
		},
		deleteuser(){
			const self = this,
				  url = (this.data && this.data.urls && this.data.urls.delete ? this.data.urls.delete : this.$store.getters.channel.urls.user.replace(':id:', this.data.id));

			self.loading = true;
			this.restdelete(url, 'delete')
			.then(message => {
				self.loading = false;
				self.$emit('delete');
				this.stopdeleteuser();
			});

		},
		stopdeleteuser(){
			this.deleteel = false;
			this.isdeleting = false;
		},
	}
}
</script>

<style scoped>
.st-table-action--active {
	opacity: 1;
}
.UserCard {
	transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
	border-radius: 5px;
	background: #fff;
	box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
	padding: 16px;
}
.UserCard__img {
	max-width: 50px;
	border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/c-user.vue